import { 
  Injectable,  
  ComponentFactoryResolver,  
  ViewContainerRef,
  Type,
  ComponentRef
} from '@angular/core';
import { Obj } from '../../utils';
import { IComponentResolverService } from '../interfaces';
export class ComponentResolverService implements IComponentResolverService {
/**
 * @param {?} _componentFactoryResolver
 */
constructor(private _componentFactoryResolver: ComponentFactoryResolver) { }
/**
 * Creates and returns a new instance of the given Component
 * @template T
 * @param {?} component
 * @param {?} viewContainerRef
 * @return {?}
 */
public createComponent<T>(
    component: Type<T>,
    viewContainerRef: ViewContainerRef
  ): ComponentRef<T> {

    if(Obj.isNullOrUndefined(component) || Obj.isNullOrUndefined(viewContainerRef)) {
      throw Error('Component Type or View Container is null or undefined');
    }
    let /** @type {?} */ factory = this._componentFactoryResolver.resolveComponentFactory(component);
    let /** @type {?} */ createdComponent = viewContainerRef.createComponent(factory);
    createdComponent.changeDetectorRef.detectChanges();
    return createdComponent;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ComponentFactoryResolver, },
];
}

function ComponentResolverService_tsickle_Closure_declarations() {
/** @type {?} */
ComponentResolverService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ComponentResolverService.ctorParameters;
/** @type {?} */
ComponentResolverService.prototype._componentFactoryResolver;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
